<template>
  <div class="vmp-chat-user-control-wrap" v-show="isShow" @click.capture="isShow = false">
    <div class="vmp-chat-user-control" :style="style">
      <div class="vmp-chat-user-control__item" @click="reply(count)" v-if="!isSelf">
        <i></i>
        <span>{{ $t('host.k_514001') }}</span>
      </div>
      <div
        :class="
          this.atList.find(u => u.nickname === this.nickname)
            ? 'vmp-chat-user-control__item disabled'
            : 'vmp-chat-user-control__item'
        "
        v-if="!isSelf"
        @click="atUser(count)"
      >
        <i></i>
        <span>{{ $t('host.k_514002') }}</span>
      </div>
      <div class="vmp-chat-user-control__item" @click="deleteMsg(count)" v-if="delAuth">
        <i></i>
        <span>{{ $t('host.k_514003') }}</span>
      </div>
      <div
        class="vmp-chat-user-control__item"
        @click="setBanned"
        v-if="godMode && !isInGroup && !isSelf && !extra_identity && role != 2"
      >
        <i></i>
        <span>{{ userStatus.is_banned ? $t('host.k_514004') : $t('host.k_514005') }}</span>
      </div>
      <div
        class="vmp-chat-user-control__item"
        @click="setKicked"
        v-if="godMode && !isInGroup && !isSelf && !extra_identity && role != 2"
      >
        <i></i>
        <span>{{ userStatus.is_kicked ? $t('host.k_514006') : $t('host.k_514007') }}</span>
      </div>
      <div
        class="vmp-chat-user-control__item"
        @click="setGlobalKicked"
        v-if="godMode && !isInGroup && !isSelf && !extra_identity && !auth_gd && role != 2"
      >
        <i></i>
        <span>{{ userStatus.is_global_kicked ? $t('host.k_514008') : $t('host.k_514009') }}</span>
      </div>
      <div
        class="vmp-chat-user-control__item"
        @click="recommendMsg"
        v-if="!isInGroup && curMsg?.msgId && curMsg.content.text_content && !auth_gd && role != 2"
      >
        <i></i>
        <span>{{ isRecommendMsg ? $t('host.k_514010') : $t('host.k_514011') }}</span>
      </div>
    </div>
  </div>
</template>
<script>
  import EventBus from '../../../common/js/Events.js';
  import { useChatServer, useRoomBaseServer, useGroupServer } from 'middle-domain';
  import { cl_kickout, cl_banned, cl_permit } from '@/app-shared/client/client-methods.js';
  export default {
    name: 'chatUserControl',
    props: {
      //房间号
      roomId: {
        type: [String, Number],
        required: true,
        default: ''
      },
      //用户id
      userId: {
        type: [String, Number],
        required: true,
        default: ''
      },
      //回复选中用户
      reply: {
        type: Function,
        required: true
      },
      //@选中用户
      atUser: {
        type: Function,
        required: true
      },
      //当前@的人员
      atList: {
        type: Array,
        required: true,
        default: () => {
          return [];
        }
      }
    },
    data() {
      return {
        //是否显示
        isShow: false,
        //动态的样式
        style: {},
        //用户状态
        userStatus: {
          is_banned: null,
          is_kicked: null,
          is_global_kicked: null
        },
        //昵称
        nickname: '',
        // 最高权限
        godMode: false,
        //删除权限
        delAuth: false,
        //助理等参会人权限
        assistantType: '',
        isSelf: true,
        count: '',
        extra_identity: null,
        isRecommendMsg: false,
        curMsg: null //当前处理的消息
      };
    },
    beforeCreate() {
      this.chatServer = useChatServer();
      this.roomBaseServer = useRoomBaseServer();
      this.groupServer = useGroupServer();
    },
    computed: {
      // 是否在小组中
      isInGroup() {
        return !!this.groupServer.state.groupInitData?.isInGroup;
      },
      // guodu  权限
      auth_gd() {
        return this.$domainStore.state.roomBaseServer.embedSource == 'gd';
      },
      //1无感知，0有感知
      banned_mode() {
        return this.$domainStore.state.roomBaseServer.interactToolStatus.banned_mode;
      },
      role() {
        return this.$domainStore.state.roomBaseServer.watchInitData.join_info.role_name;
      }
    },
    created() {
      this.assistantType = this.$route.query.assistantType;
    },
    mounted() {
      //聊天中更改人员状态
      EventBus.$on(
        'set_person_status_in_chat',
        async (el, accountId, count, nickname, msgRoleName, extra_identity, is_chatbot, msg) => {
          this.isRecommendMsg = this.chatServer.state.chatMsgRecommend?.msg_id == msg.msgId;
          this.curMsg = msg;
          // console.log(el, accountId, count, nickname, msgRoleName);
          this.extra_identity = extra_identity || is_chatbot;
          const roleName = this.roomBaseServer.state.watchInitData.join_info.role_name;
          if (accountId == this.userId) {
            this.isSelf = true;
          } else {
            this.isSelf = false;
          }
          this.accountId = accountId;
          this.count = count;
          if (roleName == 3 || roleName == 4 || roleName == 1) {
            const boundedList = await this.getUserStatus();
            this.userStatus.is_banned = boundedList[0].data.list.some(user => {
              return user.account_id == accountId;
            });
            this.userStatus.is_kicked = boundedList[1].data.list.some(user => {
              return user.account_id == accountId;
            });
            const globalKickedInfo = boundedList[2].data.list.find(user => {
              return user.account_id == accountId;
            });
            this.userStatus.is_global_kicked = !!globalKickedInfo;
            globalKickedInfo && this.$set(this.userStatus, 'global_kicked_id', globalKickedInfo.id);
            // this.isShow = true;
            this.godMode =
              [1, '1'].includes(roleName) ||
              ([3, '3', 4, '4'].includes(roleName) && msgRoleName == 2);
            this.delAuth = [1, '1', 3, '3', 4, '4'].includes(roleName) && !this.auth_gd;
          }
          this.calculate(el);
          this.nickname = nickname;
          this.roleName = roleName;
          this.isShow = (this.auth_gd && !this.isSelf) || !this.auth_gd; //国都项目删除被隐藏了，导致唯一子菜单项消失
        }
      );
    },
    methods: {
      // 监听客户端踢出操作
      assistantKickout(msg) {
        if (msg.type == 0) return;
        this.chatServer
          .setKicked({
            type: msg.data.type,
            global_kicked_id: msg.data.global_kicked_id,
            room_id: this.roomId,
            receive_account_id: msg.data.receive_account_id,
            status: msg.data.status
          })
          .then(() => {
            window.vhallReportForProduct?.report(110123);
            EventBus.$emit('kicked_in_chat', { nextStatus: 1, accountId: this.accountId });
          });
      },
      //删除消息
      deleteMsg(count) {
        this.$emit('deleteMsg', count);
      },
      //计算高度
      calculate(el) {
        const rect = el.getBoundingClientRect();
        const clientHeight = this.getClientHeight();
        let modalHeight = 0;
        if (this.auth_gd) {
          modalHeight = this.godMode && !this.isSelf ? 124 : 68;
        } else {
          modalHeight = this.godMode && !this.isSelf ? 180 : 68;
        }
        // console.log(
        //   '---->>',
        //   rect,
        //   clientHeight,
        //   modalHeight,
        //   clientHeight - rect.bottom < modalHeight
        // );
        if (clientHeight - rect.bottom < modalHeight) {
          this.style = {
            top: `${rect.top - modalHeight + (this.extra_identity ? 28 * 2 : 0)}px`,
            left: `${rect.left}px`
          };
        } else {
          this.style = {
            top: `${rect.top + rect.height + 1}px`,
            left: `${rect.left}px`
          };
        }
      },
      /**
       * 得到用户状态是否被禁言/踢出
       */
      getUserStatus() {
        return Promise.all([
          this.chatServer.getBannedList({ room_id: this.roomId }),
          this.chatServer.getKickedList({ room_id: this.roomId }),
          this.chatServer.getGlobalKickedList({
            webinar_id: this.$route.params.id,
            pos: 0,
            limit: 200
          })
        ]);
      },
      /**
       * 禁言/取消禁言
       */
      setBanned() {
        const nextStatus = this.userStatus.is_banned ? 0 : 1;
        const params = {
          receive_account_id: this.accountId,
          status: nextStatus,
          room_id: this.roomId
        };

        if (this.$route.query.assistantType) {
          nextStatus == 1 ? cl_banned(this.accountId) : cl_permit(this.accountId);
          this.chatServer.setBanned(params);
          return;
        }

        // 禁言和取消禁言都需要二次确认
        let messageKey = '';
        if (nextStatus === 1) {
          // 执行禁言
          messageKey = this.banned_mode === 0 ? 'host.k_514022' : 'host.k_514023';
        } else {
          // 取消禁言
          messageKey = 'host.k_514024';
        }

        this.$vhConfirm(this.$t(messageKey), this.$t('host.k_514014'), {
          confirmButtonText: this.$t('host.k_514015'),
          cancelButtonText: this.$t('host.k_514016'),
          roundButton: true,
          dangerouslyUseHTMLString: nextStatus === 1
        })
          .then(() => {
            this.chatServer.setBanned(params);
            window.vhallReportForProduct?.report(110122);
          })
          .catch(() => {});
        return;
      },
      /**
       * 踢出/取消踢出
       */
      setKicked() {
        const nextStatus = this.userStatus.is_kicked ? 0 : 1;
        const confirmText = nextStatus ? this.$t('host.k_514012') : this.$t('host.k_514013');
        const data = {
          receive_account_id: this.accountId,
          status: nextStatus,
          room_id: this.roomId
        };
        if (this.assistantType) {
          cl_kickout({
            ...data,
            confirmText,
            roleName: this.roleName
          });
          return;
        }
        this.$vhConfirm(confirmText, this.$t('host.k_514014'), {
          confirmButtonText: this.$t('host.k_514015'),
          cancelButtonText: this.$t('host.k_514016'),
          roundButton: true
        })
          .then(() => {
            const params = {
              room_id: this.roomId,
              receive_account_id: this.accountId,
              status: nextStatus
            };
            this.chatServer.setKicked(params).then(() => {
              window.vhallReportForProduct?.report(110123);
              EventBus.$emit('kicked_in_chat', { nextStatus, accountId: this.accountId });
            });
          })
          .catch(() => {});
      },
      /**
       * 全局踢出/取消全局踢出
       */
      setGlobalKicked() {
        const nextStatus = this.userStatus.is_global_kicked ? 0 : 1;
        const confirmText = nextStatus ? this.$t('host.k_514017') : this.$t('host.k_514018');

        const data = {
          global_kicked_id: !nextStatus ? this.userStatus.global_kicked_id : undefined,
          receive_account_id: this.accountId,
          type: 2,
          status: nextStatus,
          room_id: this.roomId
        };
        if (this.assistantType) {
          cl_kickout({
            ...data,
            confirmText,
            roleName: this.roleName
          });
          return;
        }
        this.$vhConfirm(confirmText, this.$t('host.k_514014'), {
          confirmButtonText: this.$t('host.k_514015'),
          cancelButtonText: this.$t('host.k_514016'),
          roundButton: true
        })
          .then(() => {
            this.chatServer.setKicked(data).then(() => {
              window.vhallReportForProduct?.report(110123);
              EventBus.$emit('kicked_in_chat', { nextStatus, accountId: this.accountId });
            });
          })
          .catch(() => {});
      },
      /**
       * 获取窗口可视化区域高度
       */
      getClientHeight() {
        let clientHeight = 0;
        if (document.body.clientHeight && document.documentElement.clientHeight) {
          clientHeight =
            document.body.clientHeight < document.documentElement.clientHeight
              ? document.body.clientHeight
              : document.documentElement.clientHeight;
        } else {
          clientHeight =
            document.body.clientHeight > document.documentElement.clientHeight
              ? document.body.clientHeight
              : document.documentElement.clientHeight;
        }
        return clientHeight;
      },
      //设置精选消息
      async recommendMsg() {
        const res = await this.chatServer.handleRecommendMsg({
          webinar_id: this.$route.params.id,
          recommend_status: this.isRecommendMsg ? 0 : 1,
          msg_id: this.curMsg?.msgId,
          msg_content: this.curMsg?.content.text_content,
          msg_account_id: this.curMsg?.sendId
        });
        if (res.code == 200) {
          this.isRecommendMsg = !this.isRecommendMsg;
          this.$vhMessage.success(
            !this.isRecommendMsg ? this.$t('host.k_514019') : this.$t('host.k_514020')
          );
        }
      }
    }
  };
</script>
<style lang="less">
  .vmp-chat-user-control-wrap {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: transparent;
    z-index: 900;
    .vmp-chat-user-control {
      position: absolute;
      width: 96px;
      padding: 6px 0;
      background-color: #fff;
      border-radius: 4px;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
      overflow: auto !important;
      max-height: 160px;
      box-sizing: border-box;
      cursor: pointer;
      &__item {
        font-size: 14px;
        height: 28px;
        color: #666666;
        text-align: left;
        line-height: 28px;
        padding: 0 0 0 10px;
        user-select: none;
        &.disabled {
          color: #c3c3c3;
          &:hover {
            color: #c3c3c3;
            background-color: #fff;
            cursor: not-allowed;
          }
        }
        &:hover {
          color: #fff;
          background-color: var(--theme-color);
        }
      }
    }
  }
</style>
